import { render, staticRenderFns } from "./SacBarsChart.vue?vue&type=template&id=7473735c"
import script from "./SacBarsChart.vue?vue&type=script&lang=js"
export * from "./SacBarsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports